import React from "react";
import { Settings } from "lucide-react";
import { useModalStore, ModalType } from "@/store/useModalStore";

interface MicSettingsGearButtonProps {
  onDeviceConfirmed?: (deviceId: string) => void;
}

const MicSettingsGearButton: React.FC<MicSettingsGearButtonProps> = ({
  onDeviceConfirmed,
}) => {
  const { openModal, modal } = useModalStore();

  // Hide while another modal is showing to avoid stacking on top of
  // the lesson init / mic-permission flow.
  if (modal) return null;

  return (
    <button
      type="button"
      aria-label="Microphone settings"
      onClick={() =>
        openModal(ModalType.MIC_SILENCE_TEST, { onDeviceConfirmed })
      }
      className="absolute bottom-4 left-4 z-30 w-10 h-10 rounded-full bg-black/40 hover:bg-black/60 text-white flex items-center justify-center backdrop-blur-sm"
    >
      <Settings className="w-5 h-5" />
    </button>
  );
};

export default MicSettingsGearButton;
